import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";
import MultiDomainSearch from "~/react/components/multi_domain_search.tsx";
import OperationsPanel from "~/react/components/operations-panel.tsx";
import LeadLookalikes from "~/react/components/lead_lookalikes.tsx";
import LeadLookalikesSheet from "~/react/components/lead_lookalikes_sheet.tsx";
import DomainSearch from "~/react/components/domain_search.tsx";
import DomainSidepanelEmails from "~/react/components/domain_sidepanel_emails.tsx";
import Dashboard from "~/react/components/dashboard.tsx";
import DomainSignals from "~/react/components/domain_signals.tsx";
import Discover from "~/react/components/discover.tsx";
import TamCalculator from "~/react/components/tam_calculator.tsx";
import CampaignsMetrics from "~/react/components/campaigns-metrics.tsx";
import CampaignsIssues from "~/react/components/campaigns-issues.tsx";
import EmailAccountsTable from "~/react/components/email_accounts_table.tsx";
import EmailAccountsProvisioning from "~/react/components/email-accounts-provisioning.tsx";
import DomainsTable from "~/react/components/domains_table.tsx";
import { EmailAccountsCenter } from "~/react/components/email_accounts_center";
import EmailAccountsWidgets from "~/react/components/email-accounts-widgets.tsx";

const turboMount = new TurboMount();

registerComponent(turboMount, "MultiDomainSearch", MultiDomainSearch);
registerComponent(turboMount, "OperationsPanel", OperationsPanel);
registerComponent(turboMount, "LeadLookalikes", LeadLookalikes);
registerComponent(turboMount, "LeadLookalikesSheet", LeadLookalikesSheet);
registerComponent(turboMount, "DomainSearch", DomainSearch);
registerComponent(turboMount, "DomainSidepanelEmails", DomainSidepanelEmails);
registerComponent(turboMount, "Dashboard", Dashboard);
registerComponent(turboMount, "DomainSignals", DomainSignals);
registerComponent(turboMount, "Discover", Discover);
registerComponent(turboMount, "TamCalculator", TamCalculator);
registerComponent(turboMount, "CampaignsMetrics", CampaignsMetrics);
registerComponent(turboMount, "CampaignsIssues", CampaignsIssues);
registerComponent(turboMount, "EmailAccountsTable", EmailAccountsTable);
registerComponent(turboMount, "EmailAccountsProvisioning", EmailAccountsProvisioning);
registerComponent(turboMount, "DomainsTable", DomainsTable);
registerComponent(turboMount, "EmailAccountsCenter", EmailAccountsCenter);
registerComponent(turboMount, "EmailAccountsWidgets", EmailAccountsWidgets);

// to register a component use:
// registerComponent(turboMount, "Hello", Hello); // where Hello is the imported the component

// to override the default controller use:
// registerComponent(turboMount, "Hello", Hello, HelloController); // where HelloController is a Stimulus controller extended from TurboMountController

// If you want to automatically register components use:
// import { registerComponents } from "turbo-mount/registerComponents/react";
// const controllers = import.meta.glob("/controllers/**/*_controller.js", { eager: true });
// const components = import.meta.glob("/components/**/*.jsx", { eager: true });
// registerComponents({ turboMount, components, controllers });
